"use client";

import type { IconProps as _IconProps } from "@chakra-ui/react";
import { forwardRef, Icon as _Icon } from "@chakra-ui/react";

export interface IconProps extends _IconProps {}

export const Icon = forwardRef<IconProps, "svg">(({ css, ...props }, ref) => (
    <_Icon {...props} ref={ref} />
));
